var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3716 1.37415C10.0232 1.02581 9.55573 0.833313 9.0699 0.833313H2.4974C1.48906 0.833313 0.664062 1.65831 0.664062 2.66665V17.3333C0.664062 18.3416 1.4799 19.1666 2.48823 19.1666H13.4974C14.5057 19.1666 15.3307 18.3416 15.3307 17.3333V7.09415C15.3307 6.60831 15.1382 6.14081 14.7899 5.80165L10.3716 1.37415ZM10.7474 13.6666H8.91406V15.5C8.91406 16.0041 8.50156 16.4166 7.9974 16.4166C7.49323 16.4166 7.08073 16.0041 7.08073 15.5V13.6666H5.2474C4.74323 13.6666 4.33073 13.2541 4.33073 12.75C4.33073 12.2458 4.74323 11.8333 5.2474 11.8333H7.08073V9.99998C7.08073 9.49581 7.49323 9.08331 7.9974 9.08331C8.50156 9.08331 8.91406 9.49581 8.91406 9.99998V11.8333H10.7474C11.2516 11.8333 11.6641 12.2458 11.6641 12.75C11.6641 13.2541 11.2516 13.6666 10.7474 13.6666ZM8.91406 6.33331V2.20831L13.9557 7.24998H9.83073C9.32656 7.24998 8.91406 6.83748 8.91406 6.33331Z",
    fill: "#46766F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAdd);
export default __webpack_public_path__ + "static/media/note-add.49f57d3951c367839a62af053cd6863a.svg";
export { ForwardRef as ReactComponent };